<template>
    <div style="margin:75px;">
      <h4>Google Style</h4>
      <b-row>
        <b-col cols="8" size="xl">
          <div
              style="background-color: black;
          height: 60vh; border-radius: 15px" >
          </div>

        </b-col>
        <b-col cols="4">
          <b-row>
            <b-col>
              {{sessionTitle}}
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-img
                  v-if="companyImgURL"
                  v-bind="mainProps"
                  rounded
                  style="object-fit: scale-down"
                  :src="companyImgURL"
              />
              {{companyName}}
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              Number of people here
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-button
                  pill
                  variant="warning"
                  :disabled="!isRoomAvail || !isAvSetUp"
                  @click="handleStartSessionClick"
              >
                Join Now
              </b-button>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row style="margin-top: 15px">
        <b-col>
          <b-button-group>
            <b-button
                variant="outline-dark"
                @click="handleChangeRoleTo(`viewer`)">
              Viewer
            </b-button>
            <b-button
                variant="outline-dark"
                @click="handleChangeRoleTo(`host`)">
              Host
            </b-button>
            <b-button
                variant="outline-dark"
                @click="handleChangeRoleTo(`speaker`)">
              Speaker
            </b-button>
            <b-button
                variant="outline-dark"
                @click="handleChangeRoleTo(`admin`)">
              Admin
            </b-button>
          </b-button-group>
        </b-col>
      </b-row>
    </div>
</template>

<script>
export default {
  name: "Sessions_Preview",
  components: {},
  props: {
    session: {
      type: Object,
      default: () => {}
    },
    profile: {
      type: Object,
      default: () => {}
    },
    roomData: {
      type: Object,
      default: () => {}
    },
    stageRoomId: {
      type: String,
      default: null
    },
    isRoomAvail: {
      type: Boolean,
      default: false
    },
    isAvSetUp: {
      type: Boolean,
      default: false
    },
  },
  mounted() {},
  computed: {},
  methods: {
    hasPermissionFor(permittedRole){
      return this.role == permittedRole;
    },
    /*STEP 2 - JOINING */
    handleStartSessionClick(){
      this.$emit('join-room');
    },
    handleChangeRoleTo(newRole){
      this.$emit(`change-role`, newRole);
    }
  },
  data() {
    return {
      sessionTitle: this.session && this.session.session && this.session.session.title ?
          this.session.session.title : null,
      companyImgURL: this.session && this.session.session && this.session.session.companyImgURL ?
          this.session.session.companyImgURL : null,
      companyName: this.session && this.session.session && this.session.session.companyName ?
          this.session.session.companyName : null,
      mainProps: {
        blank: false,
        blankColor: "#777",
        width: 100,
        height: 50,
        class: "m1"
      },
    };
  }
};
</script>

<style lang="scss" scoped>
</style>
